









import type { PricingTableColumn } from '@getaccept/editor-lib';
import { PricingTableHelper } from '@getaccept/editor-lib';
import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'PricingTableColumnHeaders',
  props: {
    columns: { type: Array as PropType<PricingTableColumn[]>, default: () => [] },
    gridTemplateColumns: { type: String, default: '' },
    enabledColumns: { type: Array as PropType<PricingTableColumn[]>, default: () => [] },
  },
  setup() {
    return {
      getColumnDisplayName: PricingTableHelper.getColumnDisplayName,
    };
  },
});
